module.exports = "---\ntitle: Happy API\nsubtitle: Build on top of the HappyCo platform.\n---\n\nThe Happy API is a Remote Procedure Call (RPC) system. The services\nthat are available to you are organized into various packages\naccording to different use-cases.\n\nExplore the packages, including the services, methods, request and\nresponse messages that they define below. You can also\n[download an overview](/downloads/overview.pdf) of the API or\n[browse the index](reference/index).\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/reference/content/overview.md
// module id = 71
// module chunks = 0